import 'virtual:svg-icons-register'
import { createApp } from 'vue'

import AuthApp from 'client/components/signin/AuthApp.vue'
import comm from 'client/modules/comm'
import pinia from 'client/stores'
import router from 'client/components/signin/router'
import logdna from 'client/modules/browser-logger'
import initIdleLogout from 'client/sessions/initIdleLogout'

import hasFeature from 'client/plugins/hasFeature'
import i18n from 'client/plugins/i18n'
import { createVueWait } from 'vue-wait'

import '@logdna-web/styles/src/scss/core/custom.scss'
import '@logdna-web/styles/src/css/fonts.css'

import '@logdna-web/styles/src/scss/pages/signin.scss'

import { svgSpriteDirectivePlugin } from 'client/plugins/svg-sprite'
import '@logdna-web/styles/src/css/bootstrap-vue.css'

comm.init('', pinia.state.value.__csrfToken, pinia.state.value.__sessionTraceId)
logdna.init(pinia)
initIdleLogout(pinia.state.value.__account)

const app = createApp(AuthApp)
  .use(router)
  .use(pinia)
  .use(svgSpriteDirectivePlugin, { url: '' })

app.use(i18n)
app.use(hasFeature)
app.use(createVueWait())

app.mount('#auth-app-vue')
